/*
 * @Author: 姚林刚
 * @Date: 2022-04-25 09:35:24
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-03-15 17:06:23
 * @Description: file content
 */
/*
 * @Description: 车辆轨迹
 */

// import request from '@/utils/request';
import { request } from "@/api/request.js";

// 车辆轨迹查询
export function getVehicleTrace(query) {
  return request({
    url: "/../foundation/vehicle/map/trace",
    method: "post",
    params: {
      _unpack: true,
    },
    data: query,
  }).then((result) => {
    result.data = JSON.parse(JSON.stringify(result.data));
    result.data = result.data.filter((v) => {
      return v != null && v.length > 0 && v.latitude != 0 && v.longitude != 0;
    });
    result.data.forEach((v) => {
      v.sTime = v[0].createTime;
      v.eTime = v[v.length == 1 ? 0 : v.length - 1].createTime;
      v.list = JSON.parse(JSON.stringify(Array.isArray(v) ? v.filter((item) => item.latitude != 0 && item.longitude != 0) : v));
    });
    return result;
  });
}

// 轨迹查询
export function historyTrace(query) {
  return request({
    url: "/../foundation/vehicle/map/trace",
    method: "post",
    params: {
      _unpack: true,
    },
    data: query,
  }).then((result) => {
    result.data.forEach((v) => {
      if (v.length > 0) {
        v.sTime = v[0].createTime;
        v.eTime = v[v.length - 1].createTime;
        v.list = v;
      }
    });
    return result;
  });
}

// 轨迹查询--new
export function getHistoryTrace(query) {
  return request({
    url: "/../foundation/vehicle/map/traceByDrcId",
    method: "post",
    params: {
      _unpack: true,
    },
    data: query,
  }).then((result) => {
    console.log("result---->>", result);
    result.data.forEach((v) => {
      if (v.length > 0) {
        v.sTime = v[0].createTime;
        v.eTime = v[v.length - 1].createTime;
        v.list = v;
      }
    });
    return result;
  });
}

// 实时轨迹跟踪
export function vehicleMapShadow(query) {
  return request({
    url: "/../foundation/vehicle/map/shadow",
    method: "post",
    params: {
      _unpack: true,
    },
    data: query,
  }).then((result) => {
    result.data = result.data.filter((v) => {
      return v != null;
    });
    result.data.forEach((v) => {
      if (v.length > 0) {
        v.sTime = v[0].createTime;
        v.eTime = v[v.length - 1].createTime;
        v.list = v;
      }
    });
    return result;
  });
}
